var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rank-page page"
  }, [_c('m-head'), _c('div', {
    staticClass: "rank-main page-main"
  }, [_c('m-rank', {
    ref: "mRankRef",
    attrs: {
      "ranking": _vm.ranklist
    }
  })], 1), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };